module.exports = __webpack_public_path__ + "static/media/video-subscribe.2f8993f3.png";